import React from "react";
import styled from "styled-components";
import SortableTableContainer from "components/SortableTable/SortableTableContainer";
import equipmentBackgroundImage from "images/calalloyGradient.jpg";
import { media } from "utils/style-utils";
import { machines, QA, other } from "./equipment-expanded.json";
import { Visibility } from "semantic-ui-react";

const EquipmentIntro = () => (
  <IntroContainer className="section is-medium has-text-light">
    <div className="container">
      <div className="columns">
        <div className="column is-offset-6-desktop is-6-desktop is-12-touch">
          <h1 className="title is-3 has-text-light">Equipment</h1>
          <p>
            Our facility is equipped with a massive variety of machines and
            testing devices, guaranteed to fit your project's needs, no matter
            the scale.
            <br />
            <br />
            Some, like our CalAlloy Glass-to-Metal sealing furnace, have been
            with us since the beginning in 1964. Others, like our best-in-class
            Eurotech Rapido B545 Multi-Axis Turn/Mill Center, are more recent
            additions.
            <br />
            <br />
            With over five decades of machining expertise, our collection of
            equipment contains the very best machines available from every
            period of time in the age of modern machining.
          </p>
        </div>
      </div>
    </div>
  </IntroContainer>
);

const Equipment = props => (
  <div>
    <Visibility
      onBottomPassed={props.onBottomPassed}
      onBottomPassedReverse={props.onBottomPassedReverse}
      once={false}
    >
      <EquipmentIntro />
    </Visibility>
    <EquipmentList />
  </div>
);

const EquipmentList = () => (
  <div className="section">
    <div className="columns is-centered">
      <div className="column is-4">
        <h2 className="title is-3">CNC & Machining</h2>
        <SortableTableContainer tableData={machines} />
      </div>
      <div className="column is-4 is-offset-2">
        <h2 className="title is-3">Quality Assurance & Testing</h2>
        <SortableTableContainer tableData={QA} />
        <hr />
        <h2 className="title is-3">Other Equipment</h2>
        <SortableTableContainer tableData={other} />
      </div>
    </div>
  </div>
);

export default Equipment;

const IntroContainer = styled.div`
  ${media.desktop`
    background: url('${equipmentBackgroundImage}');
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: cover; `};

  ${media.touch`
    background: rgb(54,54,54);
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/Equipment/Equipment.js